// PURPOSE: Show one personal follow-up aggregator grouped by kind.
// CONTRACT: Spec 066; counts and visibility are supplied by the server.
// DEPENDS: Home projection and native record links.
// CEILING: Read-only presentation; no outbound actions.
import { Link } from 'react-router-dom';
import { HomeFollowupRow } from './home-row-actions';
import { dateLabel } from './domain';
import { ListPager, useListPage } from './pager';
export interface NeedsGroup {kind:string;label:string;count:number;items:{id:string;title:string;why:string;link:string;due:string|null}[]}
function NeedsGroupRows({group}:{group:NeedsGroup}) {
 const page=useListPage(group.items,8);
 return <><ul className="hm-list">{page.visible.map(row=><li key={row.id}>{row.why==='Follow-up due' && row.link.startsWith('/records/client/')?<HomeFollowupRow id={row.link.split('/')[3]} title={row.title} due={row.due} detail={row.why}/>:<><Link to={row.link}>{row.title}</Link><span>{row.why}{row.due?` · ${dateLabel(row.due)}`:''}</span></>}</li>)}</ul><ListPager list={page} label={group.label.toLowerCase()} /></>;
}
export function NeedsGroups({groups}:{groups:NeedsGroup[]}) {
 const present=groups.filter(g=>g.count>0);
 return present.length?<>{present.map(group=><details key={group.kind} open={group.count<=5 || present.length===1} className="needs-group"><summary>{group.label} · {group.count}</summary><NeedsGroupRows group={group}/></details>)}</>:<p className="muted">You're clear today.</p>;
}
